import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnInit {
  url: string;
  years: number;

  constructor() { }

  ngOnInit() {
    this.years = (new Date()).getFullYear();
  }

  public redSeleccionada( url: string ): void {
    this.url = url;
  }

}
